import { isGpcApplicable } from '@/features/gpc/helpers/isGpcApplicable';
import { CookiesStorageService } from '@/services/cookiesStorageService';
import { getCCPAAccess } from '@/helpers/getCCPAAccess';
import { COOKIES_KEYS } from '@/constants';

export const getChosenCookies = (
	type: 'essential' | 'functional' | 'marketing' | 'analytics',
) => {
	// GPC opt-out short-circuit: when the Global Privacy Control signal is
	// active for an in-scope user, marketing and analytics are always denied,
	// regardless of any stored consent cookie.
	if ((type === 'marketing' || type === 'analytics') && isGpcApplicable()) {
		return false;
	}

	const stored = CookiesStorageService.get(COOKIES_KEYS.SETTINGS, '');

	// CCPA (US) opt-out model: before the user makes an explicit choice there is
	// no stored consent cookie, yet the CCPA banner keeps every category ON until
	// the user clicks "Don't Sell". Default to allowed for CCPA users only. GPC
	// is handled above; GDPR/EU (opt-in) intentionally keeps the deny-by-default
	// behaviour by falling through to the stored-cookie read below.
	if (!stored && getCCPAAccess()) {
		return type ? true : stored;
	}

	if (type) {
		return stored.includes(type);
	}

	return stored;
};
